import type { IServiceJourney } from '../models/service-journey.model';
import { TranslationService } from '../services/translation.service';

export class DirectionHelper {
  public static getDirectionForDisplay(serviceJourney: IServiceJourney): string {
    if (!serviceJourney.directionDetails) return serviceJourney.direction ?? '';

    if (serviceJourney.directionDetails.fullDirection === 'Anropsstyrd') return serviceJourney.directionDetails.fullDirection;
    if (serviceJourney.directionDetails.via === undefined) return serviceJourney.directionDetails.shortDirection;
    return `${serviceJourney.directionDetails.shortDirection} ${TranslationService.get('travelplanner.via')} ${serviceJourney.directionDetails.via}`;
  }
}
